import { client } from '@api/prismic/client';
import { Tenant } from '@lib/tenants/types';
import ResolvedApi from '@prismicio/client/types/ResolvedApi';

export const getInfo = async (tenant: Tenant): Promise<ResolvedApi> => {
  const res = await client(tenant).getApi();

  return res;
};
